var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgComputerError = function SvgComputerError(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 160C124.186 160 160 124.184 160 80.001C160 35.817 124.186 0 80 0C35.814 0 0 35.817 0 80.001C0 124.184 35.814 160 80 160Z",
    fill: "#F6F0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.767 33.2606C88.767 34.1246 88.067 34.8246 87.203 34.8246H73.075C72.112 34.8246 71.332 34.0446 71.332 33.0816V31.1016H45.115V128.898H114.984V31.1016H88.767V33.2606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.247 26H43.853C41.732 26 40.013 27.719 40.013 29.84V130.16C40.013 132.281 41.732 134 43.853 134H116.247C118.368 134 120.087 132.281 120.087 130.16V29.84C120.087 27.719 118.367 26 116.247 26ZM114.984 128.897H45.115V31.102H71.332V33.082C71.332 34.045 72.112 34.825 73.075 34.825H87.203C88.067 34.825 88.767 34.125 88.767 33.261V31.102H114.984V128.897Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.671 39.9086L66.167 41.0516H65.176L65.671 39.9086ZM65.454 39.2256L64.106 42.3126H64.632L64.98 41.5036H66.362L66.714 42.3126H67.244L65.896 39.2256H65.454Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.264 42.3127H68.786V42.0867C68.643 42.2697 68.404 42.3557 68.186 42.3557C67.673 42.3557 67.343 41.9997 67.343 41.4387V40.1387H67.821V41.3607C67.821 41.7037 67.991 41.9217 68.29 41.9217C68.512 41.9217 68.694 41.7827 68.786 41.5787V40.1397H69.264V42.3127V42.3127Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.278 40.1392H73.756V40.4302C73.839 40.2652 74.06 40.1172 74.304 40.1172C74.395 40.1172 74.474 40.1302 74.526 40.1432L74.457 40.6082C74.413 40.5912 74.344 40.5822 74.27 40.5822C74.079 40.5822 73.853 40.6912 73.757 40.9172V42.3132H73.279V40.1392H73.278Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.629 42.3557C74.986 42.3557 74.547 41.8387 74.547 41.2257C74.547 40.6127 74.986 40.0957 75.629 40.0957C75.886 40.0957 76.112 40.1827 76.264 40.3387V40.1387H76.742V42.3127H76.264V42.1087C76.112 42.2687 75.885 42.3557 75.629 42.3557ZM75.685 41.9207C75.963 41.9207 76.15 41.7907 76.263 41.6167V40.8297C76.15 40.6597 75.963 40.5297 75.685 40.5297C75.303 40.5297 75.037 40.8427 75.037 41.2257C75.038 41.6077 75.303 41.9207 75.685 41.9207Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.174 39.3156L77.653 38.8486V42.3126H77.174V39.3156Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.324 39.8128C78.15 39.8128 78.007 39.6698 78.007 39.4908C78.007 39.3168 78.15 39.1738 78.324 39.1738C78.502 39.1738 78.646 39.3168 78.646 39.4908C78.646 39.6698 78.502 39.8128 78.324 39.8128ZM78.085 40.1388H78.563V42.3128H78.085V40.1388Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.997 42.3557C79.354 42.3557 78.914 41.8387 78.914 41.2257C78.914 40.6127 79.353 40.0957 79.997 40.0957C80.254 40.0957 80.48 40.1827 80.632 40.3387V40.1387H81.11V42.3127H80.632V42.1087C80.48 42.2687 80.254 42.3557 79.997 42.3557ZM80.054 41.9207C80.332 41.9207 80.519 41.7907 80.632 41.6167V40.8297C80.519 40.6597 80.332 40.5297 80.054 40.5297C79.671 40.5297 79.406 40.8427 79.406 41.2257C79.406 41.6077 79.671 41.9207 80.054 41.9207Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.543 40.1387H82.021V40.3687C82.169 40.1857 82.403 40.0947 82.66 40.0947C83.182 40.0947 83.512 40.4507 83.512 41.0117V42.3117H83.034V41.0897C83.034 40.7467 82.86 40.5287 82.556 40.5287C82.299 40.5287 82.113 40.6717 82.021 40.8717V42.3107H81.543V40.1387V40.1387Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.364 41.4908C84.525 41.7388 84.781 41.8868 85.081 41.8868C85.372 41.8868 85.581 41.7348 85.581 41.5038C85.581 41.2868 85.438 41.1428 85.142 41.0348L84.803 40.9128C84.316 40.7348 84.077 40.4648 84.077 40.0438C84.077 39.5048 84.503 39.1738 85.077 39.1738C85.459 39.1738 85.786 39.3258 86.012 39.5958L85.66 39.9388C85.508 39.7568 85.317 39.6518 85.078 39.6518C84.817 39.6518 84.591 39.7868 84.591 40.0078C84.591 40.2338 84.739 40.3338 85.06 40.4508L85.373 40.5678C85.825 40.7378 86.099 41.0108 86.099 41.4718C86.095 42.0108 85.673 42.3628 85.069 42.3628C84.569 42.3628 84.152 42.1368 83.965 41.8058L84.364 41.4908Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.321 42.3127H87.843V42.0867C87.7 42.2697 87.461 42.3557 87.243 42.3557C86.73 42.3557 86.4 41.9997 86.4 41.4387V40.1387H86.878V41.3607C86.878 41.7037 87.048 41.9217 87.348 41.9217C87.57 41.9217 87.752 41.7827 87.844 41.5787V40.1397H88.322V42.3127H88.321Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.723 40.1387H89.201V40.3387C89.353 40.1817 89.579 40.0957 89.836 40.0957C90.484 40.0957 90.923 40.6127 90.923 41.2257C90.923 41.8387 90.484 42.3557 89.836 42.3557C89.579 42.3557 89.353 42.2687 89.201 42.1077V43.2687H88.723V40.1387ZM89.784 41.9207C90.168 41.9207 90.434 41.6047 90.432 41.2197C90.429 40.7837 90.023 40.4497 89.599 40.5497C89.417 40.5927 89.288 40.6997 89.202 40.8287V41.6157C89.314 41.7907 89.501 41.9207 89.784 41.9207Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.648 40.1392H94.126V40.4302C94.209 40.2652 94.43 40.1172 94.674 40.1172C94.765 40.1172 94.844 40.1302 94.896 40.1432L94.826 40.6082C94.783 40.5912 94.713 40.5822 94.639 40.5822C94.448 40.5822 94.222 40.6912 94.126 40.9172V42.3132H93.648V40.1392Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.577 41.0217L70.355 40.9567C70.142 40.8957 70.094 40.8047 70.094 40.6997C70.094 40.5697 70.242 40.4957 70.385 40.4957C70.563 40.4957 70.702 40.5827 70.798 40.7177L71.1 40.4237C70.945 40.2117 70.7 40.0967 70.394 40.0967C69.959 40.0967 69.62 40.3317 69.616 40.7187C69.612 41.0407 69.807 41.2797 70.186 41.3837L70.377 41.4357C70.638 41.5137 70.712 41.5877 70.712 41.7137C70.712 41.8657 70.569 41.9437 70.399 41.9437C70.177 41.9437 69.964 41.8347 69.877 41.6437L69.558 41.9547C69.725 42.2237 70.037 42.3567 70.398 42.3567C70.846 42.3567 71.185 42.0997 71.185 41.6827C71.186 41.3257 70.96 41.1347 70.577 41.0217Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.88 41.8714C72.786 41.9104 72.706 41.9264 72.571 41.9264C72.367 41.9264 72.232 41.8264 72.232 41.5564V40.5654H72.88V40.1394H72.232V39.3164H71.754V40.1394H71.328V40.5654H71.754V41.6354C71.754 42.1264 72.089 42.3574 72.51 42.3574C72.651 42.3574 72.779 42.3324 72.88 42.3024V41.8714V41.8714Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.845 41.6617C92.726 41.8157 92.537 41.9207 92.272 41.9207C91.911 41.9207 91.624 41.6857 91.603 41.3297H93.312C93.316 41.2607 93.316 41.2207 93.316 41.1737C93.316 40.4737 92.838 40.0957 92.268 40.0957C91.6 40.0957 91.123 40.5977 91.134 41.2477C91.145 41.9097 91.721 42.4017 92.382 42.3517C92.747 42.3247 93.029 42.1647 93.211 41.9217L92.845 41.6617ZM92.25 40.4997C92.528 40.4997 92.78 40.6697 92.833 40.9827H91.624C91.689 40.6607 91.972 40.4997 92.25 40.4997Z",
    fill: "#260047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.623 37.6546C81.523 37.6636 81.514 37.8046 81.611 37.8276L83.786 38.3296C83.956 37.9226 83.961 37.5626 83.669 37.4756L81.623 37.6546Z",
    fill: "url(#paint0_linear_411_470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.584 37.308C85.666 37.301 85.712 37.401 85.653 37.458L83.315 39.739C83.245 39.807 83.133 39.728 83.174 39.639L83.785 38.329C83.955 37.922 83.96 37.563 83.668 37.475L85.584 37.308Z",
    fill: "url(#paint1_linear_411_470)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.409 121.457H72.379C71.408 121.457 70.613 120.662 70.613 119.691C70.613 118.72 71.408 117.925 72.379 117.925H87.409C88.38 117.925 89.175 118.72 89.175 119.691C89.174 120.662 88.38 121.457 87.409 121.457Z",
    fill: "#ED4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.107 90.2611C80.256 90.2611 81.187 89.3271 81.187 88.1701C81.187 87.0181 80.256 86.0791 79.107 86.0791C77.952 86.0791 77.021 87.0181 77.021 88.1701C77.021 89.3271 77.953 90.2611 79.107 90.2611Z",
    fill: "#ED4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.106 84.4353C77.995 84.4353 77.095 83.5333 77.095 82.4243V71.3333C77.095 70.2233 77.995 69.3223 79.106 69.3223C80.217 69.3223 81.117 70.2243 81.117 71.3333V82.4243C81.117 83.5343 80.217 84.4353 79.106 84.4353Z",
    fill: "#ED4300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.825 96.3428H57.82C57.096 96.3428 56.428 95.9528 56.071 95.3228C55.714 94.6928 55.723 93.9208 56.095 93.2988L77.634 57.3208C77.996 56.7148 78.652 56.3418 79.359 56.3418H79.36C80.068 56.3418 80.723 56.7138 81.086 57.3228L102.553 93.3008C102.923 93.9228 102.932 94.6958 102.575 95.3248C102.216 95.9548 101.548 96.3428 100.825 96.3428ZM61.367 92.3208H97.284L79.356 62.2738L61.367 92.3208Z",
    fill: "#ED4300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_411_470",
    x1: 82.3166,
    y1: 38.4333,
    x2: 83.3649,
    y2: 37.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#EA4403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2632,
    stopColor: "#EA4A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4566,
    stopColor: "#EC5A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#EE7203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7747,
    stopColor: "#F18402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8AE00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_411_470",
    x1: 83.2741,
    y1: 38.436,
    x2: 85.5716,
    y2: 38.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1155,
    stopColor: "#EA4403"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2356,
    stopColor: "#EA4A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3928,
    stopColor: "#EC5A03"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EE7203"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6535,
    stopColor: "#F18402"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8604,
    stopColor: "#F9B301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#FFD500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD500"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgComputerError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/computer-error.09636835c5df610024885a71e0d7e4ed.svg";